export const setCookie = (key, value, seconds) => {
  const expires = new Date(Date.now() + seconds * 1000).toUTCString();
  document.cookie = `${key}=${value}; expires=${expires}; path=/`;
};

export const hasCookie = (key) => {
  return document.cookie
    .split("; ")
    .some((cookie) => cookie.startsWith(`${key}=`));
};

export const getCookies = () => {
  return document.cookie.split("; ").reduce((acc, cookie) => {
    const [key, value] = cookie.split("=");
    acc[key] = value;
    return acc;
  }, {});
};

export const removeCookie = (key) => {
  document.cookie = `${key}=; max-age=0;`;
};

export const utf8Unescape = (str) => {
  return unescape(encodeURIComponent(str));
};

export const utf8Escape = (str) => {
  return decodeURIComponent(escape(str));
};

export const encoded = (data, isObj) => {
  const base64 = isObj
    ? btoa(utf8Unescape(JSON.stringify(data)))
    : btoa(utf8Unescape(data));
  const safeBase64 = base64
    .replace(/\+/g, "-") // + → -
    .replace(/\//g, "_") // / → _
    .replace(/=+$/, ""); // = 패딩 제거
  return safeBase64;
};

export const decoded = (data, isObj) => {
  let base64 = data
    .replace(/-/g, "+") // - → +
    .replace(/_/g, "/"); // _ → /

  // 패딩 복원
  const padLength = 4 - (base64.length % 4);
  if (padLength !== 4) {
    base64 += "=".repeat(padLength);
  }

  return isObj
    ? JSON.parse(utf8Escape(atob(base64)))
    : utf8Escape(atob(base64));
};

export function getLineCount(el) {
  if (!el) return 0;

  const computed = getComputedStyle(el);
  let lineHeight = computed.lineHeight;
  if (lineHeight === "normal") {
    const fontSize = parseFloat(computed.fontSize); // px 단위 제거
    lineHeight = fontSize * 1.5; // 경험상 1.5 정도가 평균
  } else {
    lineHeight = parseFloat(lineHeight);
  }

  const height = parseFloat(el.clientHeight);
  return Math.round(height / lineHeight);
}

export const encodeKoreanOnly = (url) => {
  return url.replace(/[\u3131-\uD79D]/g, (ch) => encodeURIComponent(ch));
};

export const encodeFileNameOnly = (url) => {
  const lastSlashIndex = url.lastIndexOf("/");
  const baseUrl = url.substring(0, lastSlashIndex + 1); // 슬래시 포함
  const fileName = url.substring(lastSlashIndex + 1);
  return baseUrl + encodeURIComponent(fileName);
};
